/* flav-cart-sync-p1
   Regressieherstel winkelmand. Na elke cart-mutatie (toevoegen, aantal
   wijzigen, verwijderen, legen) lopen drie punten gegarandeerd mee met de
   cart-JSON uit de respons:
   1. het aantal in het winkelwagenbolletje in de header,
   2. het totaalbedrag in cart en drawer,
   3. de zichtbaarheid en resetstatus van de 18+ verklaring.
   Waarom hier en niet in de theme-componenten: badge en 18+ status hangen in
   Horizon aan een event-promise-keten plus een section-morph. De header-sectie
   zit niet in de section-render van /cart/change en de optimistic remove kan
   die keten doorkruisen. Deze laag kijkt niet naar die keten maar naar de
   netwerkrespons zelf en werkt daardoor voor elk mutatiepad. Volledig
   additief: bestaande componenten blijven ongemoeid en mogen daarna alsnog
   morphen; de server-render komt op dezelfde staat uit. */
(function () {
  if (window.flavCartSync) return;
  window.flavCartSync = true;

  var origFetch = window.fetch;

  window.fetch = function (input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && typeof input.url === 'string') url = input.url;
    var mutatie = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var p = origFetch.apply(this, arguments);
    if (!mutatie) return p;
    return p.then(function (res) {
      if (res && res.ok) {
        res
          .clone()
          .json()
          .then(function (data) {
            if (data && typeof data.item_count === 'number') sync(data);
            else haalCart();
          })
          .catch(haalCart);
      }
      return res;
    });
  };

  /* /cart/add.js geeft alleen de toegevoegde regel terug, geen cart. Dan halen
     we de actuele cart apart op. */
  function haalCart() {
    origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(sync)
      .catch(function () {});
  }

  /* Zelfde notatie als Liquid money zonder euroteken: 4590 wordt 45,90. */
  function formatteer(centen) {
    return new Intl.NumberFormat('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(centen / 100);
  }

  function sync(cart) {
    var aantal = cart.item_count;

    /* 1. Badge in de header, plus de sessionStorage die cart-icon.js zelf
       gebruikt om de badge te herstellen bij bfcache-navigatie. */
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      var count = icon.querySelector('[ref="cartBubbleCount"]');
      var bubble = icon.querySelector('[ref="cartBubble"]');
      if (count) {
        count.textContent = aantal < 100 ? String(aantal) : '';
        count.classList.toggle('hidden', aantal === 0);
      }
      if (bubble) bubble.classList.toggle('visually-hidden', aantal === 0);
      icon.classList.toggle('header-actions__cart-icon--has-cart', aantal > 0);
    });
    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: String(aantal), timestamp: Date.now() })
      );
    } catch (e) {
      /* privacy-modus zonder storage, geen probleem */
    }

    /* 2. Totaalbedrag in cart en drawer. */
    var totaal = formatteer(cart.total_price);
    document.querySelectorAll('[ref="cartTotal"]').forEach(function (el) {
      el.setAttribute('value', totaal);
      el.textContent = totaal;
    });

    /* 3. De 18+ verklaring: zichtbaar zodra er alcohol in de mand zit, na
       elke mutatie opnieuw leeg, en een eerdere foutmelding verdwijnt. */
    document.querySelectorAll('[data-flav-18-blok]').forEach(function (blok) {
      var typen = (blok.getAttribute('data-flav-18-typen') || '')
        .split('||')
        .map(function (t) {
          return t.trim();
        })
        .filter(Boolean);
      /* Faalveilig zoals de Liquid-kant: zonder typenlijst telt elke gevulde
         mand als alcohol. */
      var alcohol =
        typen.length === 0
          ? aantal > 0
          : (cart.items || []).some(function (item) {
              return typen.indexOf((item.product_type || '').trim()) !== -1;
            });
      blok.hidden = !alcohol;
      var vink = blok.querySelector('[data-flav-18]');
      if (vink) vink.checked = false;
      var fout = blok.querySelector('[data-flav-18-fout]');
      if (fout) fout.hidden = true;
      var wrap = blok.closest('[data-flav-cart-legal]');
      if (wrap) wrap.classList.remove('is-fout');
    });
  }
})();
